import { getActionName } from './utils';

const loadingReducer = (state = {}, action) => {
  const { type, id = null } = action;
  const matches = /(.*)_(REQUEST|SUCCESS|FAILURE)$/.exec(type);

  // Not a *_REQUEST / *_SUCCESS / *_FAILURE, so we ignore them
  if (!matches) return state;

  const [, requestName, requestState] = matches;

  return {
    ...state,
    [getActionName({ type: requestName, id })]: requestState === 'REQUEST',
  };
};

export default loadingReducer;
